import { graphql } from 'gatsby';
import React from 'react';
import { PrevNextArticleLinks } from '../modules/article/PrevNextArticleLinks';
import { ArticleTemplateQuery } from '../../graphql-types';
import { Article } from '../modules/article/Article';
import { Breadcrumb } from '../components/2.0version/breadcrumb/Breadcrumb';
import * as styles from './articleTemplate.module.scss';

interface IArticleTemplate {
  data?: ArticleTemplateQuery;
}

const ArticleTemplate = ({ data }: IArticleTemplate) => (
  <>
    <div className={styles.wrapper}>
      <div className={styles.breadcrumbWrapper}>
        <Breadcrumb />
      </div>
      <Article data={data} otList={data?.allIngenieOt} />
    </div>
    <PrevNextArticleLinks data={data} />
  </>
);

export const QUERY = graphql`
  query ArticleTemplate($id: String, $code: [String]) {
    sanityIncontournablesItem(id: { eq: $id }) {
      _rawMetadata
      id
      pageHeader {
        _rawDescription
        _rawTitle
      }
      image {
        alt
        image {
          asset {
            gatsbyImageData(placeholder: NONE)
          }
        }
      }
      content {
        ...articleContentFragment
      }
    }

    sanityBlogArticle(id: { eq: $id }) {
      _rawMetadata
      id
      category {
        _rawSlug
      }
      pageHeader {
        _rawDescription
        _rawTitle
      }
      image {
        alt
        image {
          asset {
            gatsbyImageData
          }
        }
      }
      content {
        ...articleContentFragment
      }
    }

    allIngenieOt(filter: { codeOt: { in: $code } }) {
      nodes {
        ...cardOtFragment
        pictosPartners {
          url
          alt
        }
      }
    }

    allSanityIncontournablesItem {
      nodes {
        id
        slug {
          current
        }
        pageHeader {
          _rawTitle
        }
      }
    }

    allSanityBlogArticle {
      nodes {
        id
        slug {
          current
        }
        pageHeader {
          _rawTitle
        }
      }
    }

    sanityIncontournablesPage {
      pageHeader {
        _rawTitle
      }
    }

    sanityBlogPage {
      pageHeader {
        _rawTitle
      }
    }
  }
`;

export default ArticleTemplate;
